module.exports = __webpack_public_path__ + "img/图片12.2b39c97c.png";